import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({ label, error, icon, className = '', value, ...props }) => {
  // Handle number inputs properly - preserve empty string when user clears the field
  const isNumberInput = props.type === 'number';
  const inputValue = isNumberInput 
    ? (value === 0 ? '0' : value ?? '')
    : (value ?? '');

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-slate-700 mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          className={`
            w-full rounded-lg border bg-white px-3 py-2.5 text-sm text-slate-900 shadow-sm transition-colors 
            placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-offset-0
            ${error 
              ? 'border-red-300 focus:border-red-500 focus:ring-red-200' 
              : 'border-slate-300 focus:border-primary-500 focus:ring-primary-100'}
            ${icon ? 'pl-10' : ''}
            ${props.disabled ? 'opacity-60 cursor-not-allowed bg-slate-50' : ''}
            ${className}
          `}
          value={inputValue}
          {...props}
        />
        {icon && (
          <div className="absolute left-3 top-2.5 text-slate-400 pointer-events-none">
            {icon}
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1 text-xs text-red-500">{error}</p>
      )}
    </div>
  );
};